module.exports = __webpack_public_path__ + "img/communication.05fd3d2b.png";